// extracted by mini-css-extract-plugin
export var articleBlock = "lcArticleBody-module--articleBlock--4f0dc";
export var buttonPrimary = "lcArticleBody-module--buttonPrimary--c0154";
export var container = "lcArticleBody-module--container--b99c2";
export var faqsSection = "lcArticleBody-module--faqsSection--4bf53";
export var headingEmbed = "lcArticleBody-module--headingEmbed--6fd00";
export var htmlEmbed = "lcArticleBody-module--htmlEmbed--40244";
export var imgCtn = "lcArticleBody-module--imgCtn--6a7fc";
export var videoCtn = "lcArticleBody-module--videoCtn--e4a57";
export var wistiaVideoEmbed = "lcArticleBody-module--wistiaVideoEmbed--731dc";